<template>
  <v-container flex>
    <!-- TODO make this screen look better -->
    Please wait a moment, app is loading
  </v-container>
</template>

<script>
export default {
  name: 'SplashScreen',
  data: () => ({})
}
</script>

<style></style>
